<div
  [stickyPopover]="contentTemplate"
  [popoverTitle]="popTitle"
  [autoClose]="false"
  [animation]="false"
  [openDelay]="300"
  popoverClass="header-filter-info-popover"
  placement="end-top"
  triggers="manual"
>
  <ng-content select="content"></ng-content>
</div>

<ng-template #popTitle>
  {{ searchInput.label }}
</ng-template>

<ng-template #contentTemplate>
  <ng-container *ngIf="sourceResolved?.oName?.length > 0; else otherFilters">
    <div class="container d-flex">
      <div class="left-content" style="width: 70%;">
        <ng-container *ngTemplateOutlet="otherFilters"></ng-container>
      </div>
      <div class="right-content">
        <lib-source-resolver-info 
          *ngIf="sourceResolved?.oName?.length > 0" 
          [sourceResolved]="sourceResolved">
        </lib-source-resolver-info>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #otherFilters>
  <ul class="list list-unstyled mb-0 d-flex flex-column gap-2" style="max-width: 20rem">
    <li *ngIf="searchInput.info">
      <strong>Info</strong>: <span [innerHtml]="searchInput.info"></span>
    </li>
    <li *ngIf="searchInput.description">
      <strong>Description</strong>: <span [innerHtml]="searchInput.description"></span>
    </li>
    <li *ngIf="searchInput.units">
      <strong>Units</strong>: <span [innerHtml]="searchInput.units"></span>
    </li>
    <li *ngIf="searchInput.examples">
      <strong>Examples</strong>:
      <ul class="list">
        <li *ngFor="let example of searchInput.examples">
          <a class="d-block" href="javascript:void(0)" (click)="emitExample(example)">
            {{ example }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</ng-template>
